import { css } from 'styled-components';

export default breakpoint => (...styles) => css`
  @media only screen and (min-width: ${breakpoint + 1}px) {
    ${css(...styles)}
  }
`;
